import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { ComponiFatturaPRSempliceComponent } from './componi-fattura-pr-semplice';

// @ngInject
let stateConfig = ($stateProvider: ng.ui.IStateProvider) => {

    $stateProvider
        .state('home.componi-fattura-pr-semplice', {
            url: '/componi-fattura-pr-semplice',
            params: {
                xmlpath: '',
                requestNotaCredito: false
            },
            ncyBreadcrumb: {
                label: 'Componi Fattura Semplice',
                parent: 'home.fatturazione-pr'
            },
            data: {
                authorisationLevel: 1,
                pageTitle: 'Componi fattura semplice e genera XML'
            },
            'views': {
                'homeContent': {
                    template: '<componi-fattura-pr-semplice flex="100"></componi-fattura-pr-semplice>'
                }
            }
        });
};

stateConfig.$inject = ['$stateProvider'];

export const ComponiFatturaPRSempliceModule: string = ng
    .module('componi-fattura-pr-semplice', [
        'ui.bootstrap',
        uiRouter
    ])
    .component('componiFatturaPrSemplice', ComponiFatturaPRSempliceComponent)
    .config(stateConfig)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/fatturazione/fatturazione-pr/componi-fattura-pr-semplice/componi-fattura-pr-semplice.module.ts